import PropTypes from 'prop-types';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import ApprovalModalHeaderI18n from '../i18n/ApprovalModalHeaderI18n';
import ReleaseBadge from '../common/ReleaseBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalModalHeader(props) {
  const {
    approvalOperation,
    onCancel,
    approvalType
  } = props;
  return /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsxs(H2, {
      className: "display-flex align-center",
      children: [/*#__PURE__*/_jsx(ApprovalModalHeaderI18n, {
        approvalType: approvalType,
        approvalOperation: approvalOperation
      }), /*#__PURE__*/_jsx(ReleaseBadge, {
        approvalType: approvalType
      })]
    }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "approval-modal-close",
      onClick: onCancel
    })]
  });
}
ApprovalModalHeader.propTypes = {
  approvalOperation: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired
};
export default ApprovalModalHeader;